import _createClass from '@babel/runtime/helpers/esm/createClass';

/* eslint-disable */
var FunctionValidator = /*#__PURE__*/function () {
  function FunctionValidator(validator) {
    this._name = validator.name;
    this._parameters = validator.parameters;
  }

  _createClass(FunctionValidator, [{
    key: 'name',
    get: function get() {
      return this._name;
    },
    set: function set(val) {
      this._name = val;
    }
  }, {
    key: 'parameters',
    get: function get() {
      return this._parameters;
    },
    set: function set(val) {
      this._parameters = val;
    }
  }]);

  return FunctionValidator;
}();

export { FunctionValidator as default };